import { Document } from '#/models';
import { Invoice } from '#/models/invoice/Invoice';

export const getNavigationState = (items: Invoice[] | Document[], document?: Document | null) => {
  if (!document) {
    return { hasNext: false, hasPrevious: false };
  }

  const currentIndex = items.findIndex(item => {
    const isInvoice = 'documentId' in item;
    if (isInvoice) {
      return (item as Invoice).documentId === document._id;
    }
    return (item as Document)._id === document._id;
  });

  return {
    hasNext: currentIndex !== -1 && currentIndex < items.length - 1,
    hasPrevious: currentIndex > 0
  };
};
